import React from "react";
import './style.scss'
import { useTranslation } from "react-i18next";
import { useChangeLanguage, useWindowSize, getScreenInfo } from "@/hooks";
// member-mobile-logo
const MemberHeader = () => {
    const { t } = useTranslation();
    const { isMobileSize } = useWindowSize(1023);
    const { handleChangeLanguage } = useChangeLanguage();
    return (
        <div className="member header">
            <div className="memberContent">
                 <div className="member-logo">
                </div>
                <a
                    className="lang"
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        handleChangeLanguage()
                    }}
                >
                    {t("MEMBER_LANG")}
                </a>
            </div>
        </div>
    )
}

export default MemberHeader